const LIGHT_TONE = '\uD83C\uDFFB';
const MEDIUM_LIGHT_TONE = '\uD83C\uDFFC';
const MEDIUM_TONE = '\uD83C\uDFFD';
const MEDIUM_DARK_TONE = '\uD83C\uDFFE';
const DARK_TONE = '\uD83C\uDFFF';

const TONE_LENGTH = 2;

export const hasEmojiWithSkinTones = (message: string): boolean => {
  return /\p{Emoji_Modifier_Base}/u.test(message);
};

export const hasCharWithoutModifiers = (message: string): boolean => {
  return /[^\p{Emoji_Modifier_Base}]/u.test(message);
};

export const isSkinTone = (text: string): boolean => {
  return [LIGHT_TONE, MEDIUM_LIGHT_TONE, MEDIUM_TONE, MEDIUM_DARK_TONE, DARK_TONE].includes(text);
};

export const wrapEmojis = (text: string, word: string, wrap: (str: string) => string): string => {
  const emojiLength = word.length;
  const skinTonedEmojiLength = emojiLength + TONE_LENGTH;

  const matchIndexes = [];
  let i = -1;

  while ((i = text.indexOf(word, i + 1)) >= 0) matchIndexes.push(i);

  const matchRangesIndexes = matchIndexes.map((index, i) => {
    const start = index + emojiLength;
    const potentialTone = text.substring(start, start + TONE_LENGTH);

    return [index, index + (isSkinTone(potentialTone) ? skinTonedEmojiLength : emojiLength)];
  });

  let result = '';
  let lastIndex = 0;

  for (const [start, end] of matchRangesIndexes) {
    result += text.slice(lastIndex, start);
    result += wrap(text.slice(start, end));

    lastIndex = end;
  }

  result += text.slice(lastIndex);

  return result;
};
